import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "10",
  height: "16",
  viewBox: "0 0 10 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      class: "fill",
      d: "M10 1C10 0.444445 9.44444 0 8.75 0H1.25C0.555556 0 0 0.444445 0 1V15.6667C0 15.7963 0.0925928 15.9259 0.25463 15.9815C0.416667 16.0185 0.601852 16 0.717593 15.9074L5 12.4815L9.28241 15.9074C9.375 15.963 9.46759 16 9.58333 16C9.62963 16 9.69907 16 9.74537 15.9815C9.90741 15.9259 10 15.7963 10 15.6667V1Z",
      fill: "#F2994A"
    }, null, -1)
  ])))
}
export default { render: render }